import React from "react";
import {locationNamespace} from "../types/location.namespace";

export const Province = React.createContext<locationNamespace.province.context>({});

export const City = React.createContext<locationNamespace.city.context>({});

export const Area = React.createContext<locationNamespace.area.context>({});

export const Neighborhood = React.createContext<locationNamespace.neighborhood.context>({});
